(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/carousel.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/carousel.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const log = svs.core.log;
const logger = log.getLogger('lb-ui:carousel');
const _React = React,
  Children = _React.Children,
  isValidElement = _React.isValidElement,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useLayoutEffect = _React.useLayoutEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const _svs$components$lbUi$ = svs.components.lbUi.carousel,
  CarouselItem = _svs$components$lbUi$.CarouselItem,
  CarouselNavigation = _svs$components$lbUi$.CarouselNavigation,
  supportsTouch = _svs$components$lbUi$.utils.supportsTouch;
const AccessibilityCarouselNavButton = svs.components.lbUi.carousel.accessibility.AccessibilityCarouselNavButton;
const _svs$components$carou = svs.components.carousel.hooks,
  useKeyNav = _svs$components$carou.useKeyNav,
  useDrag = _svs$components$carou.useDrag,
  useStateWithPrevious = _svs$components$carou.useStateWithPrevious;
const _svs$components$lbUti2 = svs.components.lbUtils,
  clx = _svs$components$lbUti2.clx,
  onScrollEnd = _svs$components$lbUti2.onScrollEnd;

const DRAG_THRESHOLD = 50;
const DEFAULT_OPTIONS = {
  gutter: 1,
  isMobile: false,
  itemsPerPage: 4
};
const Carousel = _ref => {
  var _children, _children2, _children4, _children5, _children6, _children7, _children8;
  let branding = _ref.branding,
    children = _ref.children,
    className = _ref.className,
    label = _ref.label,
    options = _ref.options;
  children = Array.isArray(children) ? children : [children];
  const _DEFAULT_OPTIONS$opti = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options),
    cardSize = _DEFAULT_OPTIONS$opti.cardSize,
    gutter = _DEFAULT_OPTIONS$opti.gutter,
    itemsPerPage = _DEFAULT_OPTIONS$opti.itemsPerPage,
    isMobile = _DEFAULT_OPTIONS$opti.isMobile,
    selectedIndex = _DEFAULT_OPTIONS$opti.selectedIndex;
  const useSameHeight = className === null || className === void 0 ? void 0 : className.includes('carousel-items-same-height');
  const isMobileQuery = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const mobileView = isMobile || isMobileQuery;
  const isTouch = supportsTouch();
  const ref = useRef(null); 
  const keyNav = useKeyNav(); 

  const _useState = useState(Math.ceil(((_children = children) === null || _children === void 0 ? void 0 : _children.length) / itemsPerPage)),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfPages = _useState2[0],
    setNumberOfPages = _useState2[1];


  const _useStateWithPrevious = useStateWithPrevious(() => {
      const index = selectedIndex || 0;
      const pageIndex = Math.floor(index / itemsPerPage);
      if (!children.length) {
        return 0;
      }
      return pageIndex >= numberOfPages ? numberOfPages - 1 : pageIndex;
    }),
    _useStateWithPrevious2 = _slicedToArray(_useStateWithPrevious, 3),
    pageIndex = _useStateWithPrevious2[0],
    setPageIndex = _useStateWithPrevious2[1],
    lastPageIndex = _useStateWithPrevious2[2];
  const _useStateWithPrevious3 = useStateWithPrevious(() => selectedIndex || 0),
    _useStateWithPrevious4 = _slicedToArray(_useStateWithPrevious3, 3),
    slideIndex = _useStateWithPrevious4[0],
    setSlideIndex = _useStateWithPrevious4[1],
    lastSlideIndex = _useStateWithPrevious4[2];
  const savedState = useRef({
    numberOfPages,
    itemsPerPage,
    pageIndex,
    slideIndex,
    total: (_children2 = children) === null || _children2 === void 0 ? void 0 : _children2.length,
    isScrolling: false,
    scrollLeft: 0,
    useInstant: false
  });

  const _useDrag = useDrag(ref),
    disable = _useDrag.disable,
    enable = _useDrag.enable,
    isEnabled = _useDrag.isEnabled,
    release = _useDrag.release,
    registerCallbacks = _useDrag.registerCallbacks;


  const onScrollEndPromise = () => new Promise(resolve => {
    const scrollArea = ref.current;
    let tickId;
    const tick = () => {
      clearTimeout(tickId);
      tickId = setTimeout(() => {
        scrollArea === null || scrollArea === void 0 || scrollArea.removeEventListener('scroll', tick);
        resolve();
      }, 50);
    };
    scrollArea === null || scrollArea === void 0 || scrollArea.addEventListener('scroll', tick);
  });

  const handleOnScrollEnd = async newSlideIndex => {
    const scrollArea = ref.current;
    const slide = scrollArea === null || scrollArea === void 0 ? void 0 : scrollArea.children[newSlideIndex];
    const onScrollEnd = () => {
      if (slide !== document.activeElement) {
        slide.focus();
      }
    };
    if ('onscrollend' in window) {
      scrollArea === null || scrollArea === void 0 || scrollArea.addEventListener('scrollend', onScrollEnd, {
        once: true
      });
    } else {
      onScrollEndPromise().then(onScrollEnd);
    }
  };
  const previousSlide = () => {
    if (slideIndex > 0) {
      setSlideIndex(previousIndex => {
        const newSlideIndex = previousIndex - 1;
        handleOnScrollEnd(newSlideIndex);
        return newSlideIndex;
      });
    }
  };
  const nextSlide = () => {
    let newSlideIndex;
    if (slideIndex < children.length - 1) {
      setSlideIndex(previousIndex => {
        newSlideIndex = previousIndex + 1;
        handleOnScrollEnd(newSlideIndex);
        return newSlideIndex;
      });
    }
  };

  const transformCards = useCallback(el => {
    if (mobileView && className && className.includes('carousel-mobile-flat')) {
      return;
    }
    if (el) {
      const parentBounds = el.getBoundingClientRect();
      const parentCenter = Math.round(parentBounds.left + parentBounds.width / 2);
      for (let i = 0; i < el.children.length; i++) {
        const card = el.children[i];
        const cardBounds = card.getBoundingClientRect();
        const cardCenter = Math.round(cardBounds.left + cardBounds.width / 2);
        const diff = Math.abs(cardCenter - parentCenter);
        card.firstChild.style.setProperty('--offset', Math.min(1, diff / cardBounds.width));
        if (diff < 50) {
          savedState.current.mobileIndex = i;
        }
      }
    }
  }, [mobileView, className]);

  const getPositionForIndex = useCallback(index => {
    var _ref$current;
    const children = [...(((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.children) || [])];
    if (!children.length) {
      return 0;
    }
    const bounds = children[0].getBoundingClientRect();
    if (mobileView) {
      return bounds.width / 2 + index * bounds.width;
    }
    return Math.max(0, index * bounds.width);
  }, [mobileView]);

  const moveToIndex = useCallback(function (index) {
    let instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const x = getPositionForIndex(index);
    const scrollArea = ref.current;
    if (scrollArea && scrollArea.scrollLeft !== x) {
      const dist = Math.abs(scrollArea.scrollLeft - x);
      scrollArea.scrollTo({
        left: x,
        behavior: instant || dist < 2 ? 'instant' : 'smooth'
      });
    }
  }, [getPositionForIndex]);

  const onReleaseDrag = () => {
    savedState.current.isScrolling = false;
  };

  const onStart = () => {
    savedState.current.scrollLeft = ref.current.scrollLeft;
    savedState.current.isScrolling = true;
  };

  const onMove = _ref2 => {
    let x = _ref2.x;
    if (!isTouch) {
      if (Math.abs(x) > DRAG_THRESHOLD) {
        const numberOfPages = savedState.current.numberOfPages;
        release();
        if (mobileView) {
          setSlideIndex(previousIndex => {
            const newSlideIndex = Math.max(0, Math.min(children.length - 1, previousIndex - Math.sign(x)));
            handleOnScrollEnd(newSlideIndex);
            return newSlideIndex;
          });
        } else {
          setPageIndex(i => {
            const newIndex = x > 0 ? Math.max(0, i - 1) : Math.min(numberOfPages - 1, i + 1);
            savedState.current.pageIndex = newIndex;
            return newIndex;
          });
        }
      }
    }
  };

  const onEnd = () => {
    savedState.current.isScrolling = false;
  };

  registerCallbacks({
    onStart,
    onMove,
    onEnd,
    onReleaseDrag
  });


  useEffect(() => {
    const scrollArea = ref === null || ref === void 0 ? void 0 : ref.current;
    const handleTransforms = () => {
      transformCards(scrollArea);
      if (!savedState.current.isScrolling) {
        savedState.current.isScrolling = onScrollEnd(scrollArea, () => {
          savedState.current.isScrolling = false;
        });
      }
    };
    if (mobileView) {
      scrollArea === null || scrollArea === void 0 || scrollArea.addEventListener('scroll', handleTransforms);
    }
    return () => {
      scrollArea === null || scrollArea === void 0 || scrollArea.removeEventListener('scroll', handleTransforms);
    };
  }, [mobileView, transformCards]);

  useEffect(() => {
    if (!mobileView) {
      if (pageIndex !== lastPageIndex) {
        moveToIndex(pageIndex * itemsPerPage, lastPageIndex === undefined);
      }
    }
  }, [pageIndex, lastPageIndex, mobileView, moveToIndex, itemsPerPage]);

  useEffect(() => {
    if (slideIndex !== lastSlideIndex) {
      moveToIndex(slideIndex, lastSlideIndex === undefined);
    }
    savedState.current.useInstant = false;
  }, [lastSlideIndex, moveToIndex, slideIndex]);

  useEffect(() => {
    var _children3;
    const numberOfPages = savedState.current.numberOfPages;
    const newNumberOfPages = Math.ceil(((_children3 = children) === null || _children3 === void 0 ? void 0 : _children3.length) / itemsPerPage);
    if (newNumberOfPages !== numberOfPages) {
      savedState.current.numberOfPages = newNumberOfPages;
      setNumberOfPages(newNumberOfPages);

      moveToIndex(0, true);
      setPageIndex(0);
      setSlideIndex(0);
    }
  }, [(_children4 = children) === null || _children4 === void 0 ? void 0 : _children4.length, itemsPerPage, moveToIndex, setPageIndex, setSlideIndex]);
  useEffect(() => {
    const scrollArea = ref.current;
    if (mobileView && scrollArea) {
      setTimeout(() => {
        transformCards(scrollArea);
      }, 200);
    }
  }, [mobileView, transformCards]);
  useEffect(() => {
    const scrollArea = ref.current;
    if (supportsTouch()) {
      const onScrollEnd = () => {
        const slides = [...(scrollArea.children || [])];
        const notHiddenIndex = slides.findIndex(slide => !slide.classList.contains('carousel-item-hidden'));
        if (slideIndex !== notHiddenIndex) {
          setSlideIndex(notHiddenIndex);
        }
      };
      if ('onscrollend' in window) {
        scrollArea === null || scrollArea === void 0 || scrollArea.addEventListener('scrollend', onScrollEnd);
      } else {
        onScrollEndPromise().then(onScrollEnd);
      }
    }
    return () => {
      scrollArea === null || scrollArea === void 0 || scrollArea.removeEventListener('scrollend', onScrollEnd);
    };
  }, []);
  useEffect(() => {
    if (isTouch && isEnabled()) {
      disable();
    } else if (!isTouch && !isEnabled()) {
      enable();
    }
  }, [disable, enable, isEnabled, isMobileQuery, isTouch]);
  useLayoutEffect(() => {
    const scrollArea = ref.current;
    if (useSameHeight && scrollArea) {
      scrollArea.style.height = '';
      [...scrollArea.children].forEach(item => {
        item.style.height = '';
      });
      let maxHeight = 0;
      const items = [...scrollArea.children].filter(child => !child.classList.contains('carousel-placeholder-item'));
      if (items.length > 0) {
        items.forEach(item => {
          if (item.offsetHeight > maxHeight) {
            maxHeight = item.offsetHeight;
          }
        });
        if (maxHeight > 0) {
          scrollArea.style.height = "".concat(maxHeight + 24, "px");
          [...scrollArea.children].forEach(item => {
            item.style.height = '100%';
          });
        }
      }
    }
  }, [useSameHeight, children, itemsPerPage, mobileView, className]);


  const styles = _objectSpread({
    '--carousel-gutter': gutter,
    '--carousel-per-page': itemsPerPage
  }, cardSize ? {
    '--carousel-card-size': "".concat(cardSize, "px")
  } : {});

  const placeholders = [...Array(Math.ceil((((_children5 = children) === null || _children5 === void 0 ? void 0 : _children5.length) || 1) / itemsPerPage) * itemsPerPage - ((_children6 = children) === null || _children6 === void 0 ? void 0 : _children6.length)).keys()].map(key => React.createElement(CarouselItem, {
    isPlaceholder: true,
    key: "placeholder-".concat(key)
  }, React.createElement("div", {
    className: "carousel-placeholder-item"
  })));
  const showNavigation = children.length > itemsPerPage && !mobileView;
  if (!((_children7 = children) !== null && _children7 !== void 0 && _children7.length)) {
    logger.debug('Carousel: No children found');
  }
  return ((_children8 = children) === null || _children8 === void 0 ? void 0 : _children8.length) > 0 ? React.createElement("section", {
    "aria-label": label,
    "aria-roledescription": "Karusell",
    className: clx('carousel', {
      ["carousel-".concat(branding)]: branding,
      'carousel-with-navigation': showNavigation,
      'carousel-mobile': mobileView
    }, className),
    "data-testid": "carousel",
    role: "region",
    style: styles
  }, showNavigation && React.createElement(CarouselNavigation, {
    disabled: children.length <= itemsPerPage,
    isKeyNav: keyNav,
    numberOfPages: numberOfPages,
    onChange: i => {
      savedState.current.tempIndex = null;
      setPageIndex(i);
    },
    selectedIndex: pageIndex
  }), mobileView && children.length > 1 && React.createElement(AccessibilityCarouselNavButton, {
    className: "a11y-carousel-nav-button-prev",
    disabled: slideIndex === 0,
    label: "F\xF6reg\xE5ende",
    onClick: previousSlide
  }), React.createElement("div", {
    className: "carousel-items",
    "data-testid": "carousel-items",
    ref: ref,
    role: "list"
  }, Children.map(children, (child, childIndex) => {
    if (isValidElement(child)) {
      return React.cloneElement(child, {
        isHidden: mobileView && childIndex !== selectedIndex && childIndex !== slideIndex,
        isSelected: childIndex === selectedIndex
      });
    }
    return null;
  }), !mobileView && placeholders), mobileView && children.length > 1 && React.createElement(AccessibilityCarouselNavButton, {
    className: "a11y-carousel-nav-button-next",
    disabled: slideIndex === children.length - 1,
    label: "N\xE4sta",
    onClick: nextSlide
  })) : null;
};
Carousel.defaultProps = {
  children: []
};
setGlobal('svs.components.lbUi.carousel.Carousel', Carousel);

 })(window);